<template>
    <div class="status-style">
        <el-icon v-if="currentStatus === 1" style="color: #0161ff">
            <RemoveFilled />
        </el-icon>
        <el-icon v-if="currentStatus === 2" style="color: #6ad929">
            <SuccessFilled />
        </el-icon>
        <el-icon v-if="currentStatus === 3" style="color: #ff5252">
            <CircleCloseFilled />
        </el-icon>
        {{ statusText }}
        <a
            v-if="row.result_url && row.result_url !== ''"
            class="download-a"
            :href="row.result_url"
            :download="row.file_name"
        >
            <svg-icon
                class="handle-icon"
                icon-class="download"
            />
        </a>
    </div>
</template>

<script lang="ts" setup>
import {onMounted, ref, computed} from 'vue';
import {useRoute} from 'vue-router';
import {useI18n} from 'vue-i18n';

const i18n = useI18n();

const emits = defineEmits(['handleClick']);
const route = useRoute();

const props = defineProps({
    row: {
        type: Object,
        default: () => ({})
    },
    column: {
        type: Object,
        default: () => ({})
    }
});
const currentStatus = computed(() => {
    if (props.row.status === 0 || props.row.status === 1) {
        return 1;
    }
    return props.row.status;
});
const statusText = computed(() => {
    const type = props.row.type;
    if (currentStatus.value === 1) {
        return i18n.t(type === 'import' ? 'btn.importings' : 'btn.exportings');
    } else if (currentStatus.value === 2) {
        return i18n.t(type === 'import' ? 'msg.importDone' : 'msg.exportDone');
    }
    return i18n.t(type === 'import' ? 'msg.importError' : 'msg.exportError');
});


// 点击链接时触发的事件
const handleClick = (row: any) => {
};

</script>

<style lang="scss" scoped>
.status-style {
    display: flex;
    align-items: center;
    gap: 5px;
    i {
        font-size: 18px;
    }
    .download-a {
        display: flex;
        align-items: center;
        svg {
            color: #000;
        }
    }
}
</style>
